import React from 'react';
import { baseUrl } from '../baseUrl';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState} from 'react';
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

// import PlusOneIcon from '@mui/icons-material/PlusOne';
// import Card from '@mui/material/Card';

export default function Songbar({...props}) {
  // const navigate = useNavigate();
  const [open, setOpen] = useState(false)
  const [openArtist,setOpenArtist] = useState(false)
  const [openGenre,setOpenGenre] = useState(false)
  const [category,setCategory] = useState('')
  const [ id_no,setId_no] = useState('')


  const imageContainerStyle = {
    width: '100%',
    height: '200px', // Adjust the height as per your requirements
    overflow: 'hidden', // Hide any overflowing content
    position: 'relative', // Needed for centering the image
  };
  
  // Style the image itself to maintain the aspect ratio
  // const imageStyle = {
  //   width: '100%',
  //   height: '80%',
  //   objectFit: 'cover', // This will maintain the aspect ratio and cover the entire container
  // };

  const handleClickDelete = (category,id_no,artist_id) => {
    // console.log(category);
    // console.log(id_no);
    if (category !== 'Artist' && category !== 'Genres'){
      setCategory(category)
      setId_no(id_no)
      setOpen(true);
      }else{
        if (category !=='Genres'){
          setCategory(category)
          setId_no(artist_id)
          setOpenArtist(true);
        }
        else{
          setCategory(category)
          setId_no(id_no)
          setOpenGenre(true);
        }
      }
  };

  const handleClose = () =>{
    setOpen(false);
  };

  const handleOkay = async() => {
    //  console.log({ "id_no": id_no,'category':category });
     if(id_no === undefined || id_no === ''){
       alert('No songs found!')
       setOpen(false);
       return;
      };
      
      try {
       const response = await axios.post(`${baseUrl}deletesongs`, { "id_no":id_no,'category':category });
       const data = await response.data;
       if (data.status.code === 200){
         setOpen(false);
         window.location.reload(true);
      }else{
        alert(data.status.message)
        setOpen(false);
    }
    }
    catch{
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Error occurred — <strong>check it out!</strong>
        </Alert>
      </Stack>
      setOpen(false);
    }
  };

  const handleCancelArtist = () =>{
    setOpenArtist(false);
    setId_no('')
  };

  const handleDeleteArtist = async() =>{
    setOpenArtist(false);
          
    try {
      const response = await axios.post(`${baseUrl}deleteArtist`, { "id_no":id_no,});
      const data = await response.data;
      if (data.status.code === 200){
        setOpenArtist(false);
        window.location.reload(true);
     }else{
       alert(data.status.message)
       setOpenArtist(false);
   }
   }
   catch{
     <Stack sx={{ width: '100%' }} spacing={2}>
       <Alert severity="error">
         <AlertTitle>Error</AlertTitle>
         Error occurred — <strong>check it out!</strong>
       </Alert>
     </Stack>
     setOpenArtist(false);
   }

  };

  const handleCancelGenre = () =>{
    setOpenGenre(false);
    setId_no('')
  };

  const handleDeleteGenre = async() =>{
    setOpenGenre(false);
    try {
      const response = await axios.post(`${baseUrl}deleteGenres`, { "id_no":id_no,});
      const data = await response.data;
      if (data.status.code === 200){
        setOpenGenre(false);
        window.location.reload(true);
     }else{
       alert(data.status.message)
       setOpenGenre(false);
   }
   }
   catch{
     <Stack sx={{ width: '100%' }} spacing={2}>
       <Alert severity="error">
         <AlertTitle>Error</AlertTitle>
         Error occurred — <strong>check it out!</strong>
       </Alert>
     </Stack>
     setOpenGenre(false);
   }
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 5 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 767, min: 464 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    }
  };



  return (
<>
    {/* delete songs */}
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Song</DialogTitle>
      <DialogContent>
        <DialogContentText>
        Are you sure you want to delete this Song? This action is irreversible, and once deleted, the song cannot be recovered.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {handleClose()}}>Cancel</Button>
        <Button onClick={() => {handleOkay()}}>Okay</Button>
      </DialogActions>
    </Dialog>

    {/* delete artist */}
    <Dialog open={openArtist} onClose={handleCancelArtist}>
      <DialogTitle>Delete Artist</DialogTitle>
      <DialogContent>
        <DialogContentText>
        Are you sure you want to delete this Artist? This action is irreversible, and once deleted, the artist cannot be recovered.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelArtist}>Cancel</Button>
        <Button onClick={handleDeleteArtist}>Okay</Button>
      </DialogActions>
    </Dialog>

    {/* delete genre */}
    <Dialog open={openGenre} onClose={handleCancelGenre}>
      <DialogTitle>Delete Genre</DialogTitle>
      <DialogContent>
        <DialogContentText>
        Are you sure you want to delete this Genre? This action is irreversible, and once deleted, the Genre cannot be recovered.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelGenre}>Cancel</Button>
        <Button onClick={handleDeleteGenre}>Okay</Button>
      </DialogActions>
    </Dialog>

    <div className="parent" >
      <Carousel
        responsive={responsive}
        autoPlay={props.searchResult.correctedQuery === "Genres" ? true : false}
        infinite={props.searchResult.correctedQuery === "Genres" ? true : false}
        draggable={false}
        swipeable={false}
        showDots={true}
        partialVisible={false}
        dotListClass="custom-dot-list-style"
      >
        {props?.searchResult?.items?.map((item) => {
          let channelTitle = '', thumbnails = '', title = '';
          if (props.searchResult.correctedQuery === "Genres") {
            thumbnails = item.image
            title = item.title
          }
          else if (props.searchResult.correctedQuery === "Artist"){
            thumbnails = item.artist_image
            title = item.artist_name
          }
          else {
            channelTitle = item?.snippet?.channelTitle??''
            thumbnails = item?.snippet?.thumbnails?.high?.url ? item?.snippet?.thumbnails?.high?.url??'' : item?.snippet?.thumbnails?.default?.url??''
            title = item?.snippet?.title??''
            // videoId = item.id.videoId video_id=''
          }
          const isGenres = (props.searchResult.correctedQuery === "Genres");
          const isArtist = (props.searchResult.correctedQuery === "Artist");

          return (
            <div className="slider">
              <div style={imageContainerStyle}>
              <img src={thumbnails} alt="ImageUrl" style={{borderRadius:( (isGenres) || (isArtist)  )?"100px":'15px', width:( (isGenres) || (isArtist)  )?'200px': '100%',height:( (isGenres) || (isArtist)  ) ?'200px': '100%',objectFit: 'cover',}} />
              </div>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="body1" color="black" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', Width: '60px' }} >
                  {title}
                </Typography>
                <Typography variant="body2" color="orangered">
                  {channelTitle}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', marginTop: 'auto'}}>
                <Button onClick={() => handleClickDelete(props.searchResult.category,item.id_no,item.artist_id)} variant="outlined" startIcon={<DeleteIcon />}>
                  Delete
                </Button>
              </CardActions>
            </div>
          );
        })}

      </Carousel>
    </div>

</>
  );
}
